import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Swords, AlertTriangle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function GoogleCallbackPage() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const accessToken = params.get('access_token');
    const errorParam = params.get('error');

    if (errorParam) {
      setError('Google sign-in was cancelled or denied.');
      return;
    }

    if (!accessToken) {
      setError('No access token received from Google. Please try again.');
      return;
    }

    loginWithGoogle(accessToken)
      .then(() => navigate('/app/feed', { replace: true }))
      .catch(err => setError(err.message || 'Google sign-in failed. Please try again.'));
  }, []);

  return (
    <div className="auth-root">
      <div className="auth-blobs">
        <div className="auth-blob auth-blob-1" />
        <div className="auth-blob auth-blob-2" />
        <div className="auth-blob auth-blob-3" />
      </div>

      <div className="auth-card-wrap">
        <div className="auth-header">
          <div className="auth-logo-link">
            <Swords size={32} color="#0EA5E9" />
          </div>
          <h1 className="auth-title">
            {error ? 'Sign-in failed' : 'Signing you in…'}
          </h1>
          <p className="auth-subtitle">
            {error ? 'Something went wrong with Google.' : 'Verifying your Google account.'}
          </p>
        </div>

        <div className="auth-card" style={{ textAlign: 'center', padding: '40px 24px' }}>
          <div className="auth-card-stripe" />
          {error ? (
            <>
              <AlertTriangle size={40} color="#F87171" style={{ marginBottom: 16 }} />
              <p style={{ color: '#F87171', marginBottom: 24, fontSize: 14 }}>{error}</p>
              <Link to="/login" className="auth-btn" style={{ display: 'inline-flex', textDecoration: 'none', width: 'auto', padding: '12px 32px' }}>
                Back to sign in
              </Link>
            </>
          ) : (
            <>
              <span className="auth-spinner" style={{ width: 32, height: 32, borderWidth: 3, display: 'inline-block', marginBottom: 16 }} />
              <p style={{ color: '#64748B', fontSize: 14 }}>Please wait…</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
